export const HOME_PAGE_RATES_CAROUSEL_UPDATE = 'home-page.rates-carousel.update';
